import {
  Component,
  computed,
  input,
  output,
  ChangeDetectionStrategy,
} from "@angular/core";
import { Icon } from "../icon/icon";

@Component({
  selector: "app-button",
  imports: [Icon],
  templateUrl: "./button.html",
  styleUrl: "./button.scss",
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: true,
})
export class Button {
  text = input.required<string>();
  variant = input<
    | "primary"
    | "secondary"
    | "tertiary"
    | "quaternary"
    | "quinary"
    | "destructive"
  >("primary");
  icon = input<string>();
  iconPosition = input<"left" | "right">("right");
  iconSize = input<string>("0.75rem");
  size = input<"md" | "sm">("sm");
  link = input<string>("");
  disabled = input<boolean>(false);
  noWhitespace = input<boolean>(true);

  extraClass = input<string>();
  extraClassForText = input<string>();
  buttonClick = output<void>();

  colorIcon = computed(() => {
    switch (this.variant()) {
      case "primary":
        return "fill-black";
      case "secondary":
        return "fill-white";
      default:
        return "fill-black";
    }
  });

  paddingSize = computed(() => {
    switch (this.size()) {
      case "md":
        return "py-4 px-6";
      case "sm":
        return "py-2 px-3";
      default:
        return "py-4 px-6";
    }
  });

  flexDirection = computed(() => {
    return this.iconPosition() === "left" ? "flex-row-reverse" : "flex-row";
  });
}
